import type { FaireProductEntity } from "../../entity_types/product";

export const p_hu4vcpjcbz: FaireProductEntity = {
  token: "p_hu4vcpjcbz",
  type: "product",
  name: "Milan Baby Button Cardigan Sweater Knit (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/8e1fa1b922ee0803156ac6e11517f3bce0e3f3e7bf31ab16a5afa32fb082b9f4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc97bed7dc31072769a0533503828c623e30f5b245bcfdbbf710e1d963d75ca0.jpeg",
    "https://cdn.faire.com/fastly/ad4e85fb313d81722cb15eeb4244ff0fcdd5d492f57310ee000991fc92dd648d.jpeg",
    "https://cdn.faire.com/fastly/c7aedfdf35e711ed08b9367b7f7a6d4a8152a48f5fae38f6cbde4d7400761acf.jpeg",
    "https://cdn.faire.com/fastly/1463502bcad099e7006bbed0c4c167fc3937dbf4701ed42a19076c09d3037768.jpeg",
    "https://cdn.faire.com/fastly/aaa0ada8f08e0ed23600c3630b765a3464293e3944340fda6a370d3046dff9e3.jpeg",
    "https://cdn.faire.com/fastly/458beec4451b65c77b754b500cf479fefba7136c3e7710bb3a64ac4605fc9b16.jpeg",
  ],
  priceDollars: 22,
  description:
    "Classic, cozy and soft baby cardigan in pure organic cotton fine sweater knit. \n\n- 100% organic cotton sweater knit button front cardigan for baby.\n- Coconut shell buttons & two cute front pockets (Mauve Pink colorway has decorative bows on each pocket).\n- Mauve Pink color has little decorative bows on the tiny front pockets.\n- Cozy, comfy, buttery soft & luxurious.\n- All-season, lightweight and breathable organic cotton.\n- Eco-friendly, chemical free, non-toxic, pure, natural & organic baby clothes.\n- Machine washable, durable and long lasting.\n- Ethically produced in India from small farmer sourced cotton.\n\nViverano, an American brand, was founded in 2013 with the simple idea of producing eco-friendly, pure and organic baby clothes. Viverano baby clothing is known for its soft hand feel and high quality. Pamper your precious babies with our non-toxic, lightweight, all-season, natural baby outfits. \n\nExperience 'Organic Comfort' by Viverano, a family-owned small business.",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:57.053Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
